<template>
  <v-col
    cols="12"
    class="pb-0"
  >
    <v-row no-gutters>
      <v-col
        :cols="$vuetify.breakpoint.xsOnly ? 12 : secondary.length > 0 ? 6 : 12"
        class="pa-0"
      >
        <div
          v-for="(value, i) in primary"
          :key="`primary_${i}`"
          class="py-1"
        >
          <v-row
            class="flex-nowrap"
            align="start"
            no-gutters
          >
            <v-icon
              left
              size="18"
              :color="value.color || 'grey lighten-4'"
            >
              fiber_manual_record
            </v-icon>
            <div>
              <div
                class="caption"
                :class="{'font-weight-bold': value.bold}"
              >
                {{ value.label }}
              </div>
              <div class="subtitle-1 font-weight-bold">
                {{ value.value }}
              </div>
            </div>
          </v-row>
          <!-- <v-row class="flex-nowrap" align="center" no-gutters>
              <div class="body-2 pr-0">{{value.label}}</div>
              <v-icon v-if="value.color" right size="18" :color="value.color">fiber_manual_record</v-icon>
            </v-row>
            <div class="subtitle-1 font-weight-bold">{{value.value}}</div> -->
        </div>
      </v-col>
      <v-col
        v-if="secondary.length > 0"
        cols="6"
        sm="6"
        class="pa-0"
      >
        <div
          v-for="(value, i) in secondary"
          :key="`secondary_${i}`"
          class="py-1"
        >
          <v-row
            class="flex-nowrap"
            align="start"
            no-gutters
          >
            <v-icon
              left
              size="18"
              :color="value.color || 'grey lighten-4'"
            >
              fiber_manual_record
            </v-icon>
            <div>
              <div
                class="caption"
                :class="{'font-weight-bold': value.bold}"
              >
                {{ value.label }}
              </div>
              <div class="subtitle-1 font-weight-bold">
                {{ value.value }}
              </div>
            </div>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    values: Object,
    colors: Array
  },
  computed: {
    primary () {
      return this.values.primary || []
    },
    secondary () {
      return this.values.secondary || []
    }
  }
}
</script>